'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var deviceProfiler = require('@narvar/device-profiler');
var noflakeSchema = require('./noflakeSchema.js');
var storage = require('./storage.js');
var decamelize = require('./decamelize.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var deviceProfiler__default = /*#__PURE__*/_interopDefaultLegacy(deviceProfiler);

let NarvarEventTypes = /*#__PURE__*/function (NarvarEventTypes) {
  NarvarEventTypes["CLICK"] = "click";
  NarvarEventTypes["COMPONENT_RENDER"] = "component_render";
  NarvarEventTypes["PAGE_LOAD"] = "page_load";
  NarvarEventTypes["WEB_VITAL"] = "web_vital";
  NarvarEventTypes["SESSION_START"] = "session_start";
  NarvarEventTypes["ERROR"] = "error";
  NarvarEventTypes["EXPERIMENT"] = "experiment";
  NarvarEventTypes["FEATURE_USAGE"] = "feature_usage";
  NarvarEventTypes["SOCKET_DISCONNECT"] = "socket_disconnect";
  NarvarEventTypes["SOCKET_CONNECT"] = "socket_connect";
  NarvarEventTypes["TRACK_QUALITY"] = "track_quality";
  return NarvarEventTypes;
}({});
let NarvarClickTypes = /*#__PURE__*/function (NarvarClickTypes) {
  NarvarClickTypes["OUTGOING"] = "outgoing";
  NarvarClickTypes["INTERACTION"] = "interaction";
  return NarvarClickTypes;
}({});
let NarvarClickSubTypes = /*#__PURE__*/function (NarvarClickSubTypes) {
  NarvarClickSubTypes["DISMISS"] = "dismiss";
  NarvarClickSubTypes["EXTERNAL_HELP_LINK"] = "external_help_link";
  NarvarClickSubTypes["EXTERNAL_RETAILER_LINK"] = "external_retailer_link";
  NarvarClickSubTypes["EXTERNAL_TRACKING_LINK"] = "external_tracking_link";
  NarvarClickSubTypes["EXTERNAL_LINK"] = "external_link";
  NarvarClickSubTypes["HIDE_SHIPPING_HISTORY"] = "hide_shipping_history";
  NarvarClickSubTypes["LOGO_ASSET"] = "logo_asset";
  NarvarClickSubTypes["COPY_LINK"] = "copy_link";
  NarvarClickSubTypes["SEND_EMAIL"] = "send_email";
  NarvarClickSubTypes["MARKETING_ASSET"] = "marketing_asset";
  NarvarClickSubTypes["MORE_INFORMATION_LINK"] = "more_information_link";
  NarvarClickSubTypes["NAVIGATION_ELEMENT"] = "navigation_element";
  NarvarClickSubTypes["SHOW_SHARING_OPTIONS"] = "show_sharing_options";
  NarvarClickSubTypes["PICKUP_LOCATION_DIRECTIONS_LINK"] = "pickup_location_directions_link";
  NarvarClickSubTypes["PICKUP_LOCATION_PHONE_LINK"] = "pickup_location_phone_link";
  NarvarClickSubTypes["PICKUP_LOCATION_SHOW_HOURS_LINK"] = "pickup_location_show_hours_link";
  NarvarClickSubTypes["PICKUP_LOCATION_HIDE_HOURS_LINK"] = "pickup_location_hide_hours_link";
  NarvarClickSubTypes["RATING"] = "rating";
  NarvarClickSubTypes["SHOW_SHIPPING_HISTORY"] = "show_shipping_history";
  NarvarClickSubTypes["SHARE_LINK"] = "share_link";
  NarvarClickSubTypes["SMS_NUMBER_UPDATE"] = "sms_number_update";
  NarvarClickSubTypes["SMS_SIGNUP"] = "sms_signup";
  NarvarClickSubTypes["SMS_SIGNUP_AGAIN"] = "sms_signup_again";
  NarvarClickSubTypes["SMS_UNSUBSCRIBE"] = "sms_unsubscribe";
  NarvarClickSubTypes["EMAIL_UPDATE"] = "email_update";
  NarvarClickSubTypes["EMAIL_SIGNUP"] = "email_signup";
  NarvarClickSubTypes["EMAIL_SIGNUP_AGAIN"] = "email_signup_again";
  NarvarClickSubTypes["EMAIL_UNSUBSCRIBE"] = "email_unsubscribe";
  NarvarClickSubTypes["LINE_SIGNUP"] = "line_signup";
  NarvarClickSubTypes["LINE_UNSUBSCRIBE"] = "line_unsubscribe";
  NarvarClickSubTypes["LINE_SIGNUP_AGAIN"] = "line_signup_again";
  NarvarClickSubTypes["SURVEY_SUBMIT"] = "survey_submit";
  NarvarClickSubTypes["PRODUCT_RECOMMENDATIONS"] = "product_recommendations";
  NarvarClickSubTypes["DELIVERY_INSTRUCTIONS"] = "delivery_instructions";
  NarvarClickSubTypes["ITEMS_IN_THIS_SHIPMENT"] = "items_in_this_shipment";
  NarvarClickSubTypes["SHIPMENTS"] = "shipments";
  NarvarClickSubTypes["GIFT_TRACKING"] = "gift_tracking";
  NarvarClickSubTypes["CALLING_DRIVER"] = "calling_driver";
  NarvarClickSubTypes["TEXTING_DRIVER"] = "texting_driver";
  NarvarClickSubTypes["VPOD_EXPAND"] = "vpod_expand";
  NarvarClickSubTypes["VPOD_CONTRACT"] = "vpod_contract";
  NarvarClickSubTypes["CHAT_INTERACTION"] = "chat_interaction";
  NarvarClickSubTypes["CHAT_INPUT_SUBMIT"] = "chat_input_submit";
  NarvarClickSubTypes["CHAT_CHIP_SELECT"] = "chat_chip_select";
  NarvarClickSubTypes["ASSIST_PORTAL_LINK"] = "assist_portal_link";
  NarvarClickSubTypes["HIGHLIGHT_TEXT"] = "highlight_text";
  NarvarClickSubTypes["COPIED_TEXT"] = "copied_text";
  NarvarClickSubTypes["TRACKING_NUMBER"] = "tracking_number";
  NarvarClickSubTypes["REFRESH_SHIPPING_HISTORY"] = "refresh_shipping_history";
  return NarvarClickSubTypes;
}({});
let NarvarEventComponents = /*#__PURE__*/function (NarvarEventComponents) {
  NarvarEventComponents["NTH_BLOCK_ASSET"] = "nth-block-asset";
  NarvarEventComponents["NTH_BLOCK_BROADCAST_BANNER"] = "nth-block-broadcast-banner";
  NarvarEventComponents["NTH_BLOCK_CARRIER_TRACKING_LINK"] = "nth-block-carrier-tracking-link";
  NarvarEventComponents["NTH_BLOCK_CUSTOM_COMPONENT"] = "nth-block-custom-component";
  NarvarEventComponents["NTH_BLOCK_DELIVERY_STATUS"] = "nth-block-delivery-status";
  NarvarEventComponents["NTH_BLOCK_DRIVER_DETAILS"] = "nth-block-driver-details";
  NarvarEventComponents["NTH_BLOCK_EDD"] = "nth-block-edd";
  NarvarEventComponents["NTH_BLOCK_HELP_PILL"] = "nth-block-help-pill";
  NarvarEventComponents["NTH_BLOCK_MAPTILER_MAP"] = "nth-block-maptiler-map";
  NarvarEventComponents["NTH_BLOCK_NOTIFICATION_CENTER_DISCLAIMER_TEXT"] = "nth-block-notification-center-disclaimer-text";
  NarvarEventComponents["NTH_BLOCK_SECTION_DIVIDER"] = "nth-block-section-divider";
  NarvarEventComponents["NTH_BLOCK_STAR_RATING"] = "nth-block-star-rating";
  NarvarEventComponents["NTH_BLOCK_TELEPHONE_INPUT"] = "nth-block-telephone-input";
  NarvarEventComponents["NTH_BLOCK_TRACKING_STATUS"] = "nth-block-tracking-status";
  NarvarEventComponents["NTH_BUNDLE_DYNAMIC_HEADER"] = "nth-bundle-dynamic-header";
  NarvarEventComponents["NTH_BUNDLE_NARVAR_FOOTER"] = "nth-bundle-narvar-footer";
  NarvarEventComponents["NTH_BUNDLE_SHIPPING_ACTIVITY"] = "nth-bundle-shipping-activity";
  NarvarEventComponents["NTH_BUNDLE_VPOD"] = "nth-bundle-vpod";
  NarvarEventComponents["NTH_KIT_DYNAMIC_LAYOUT_NEXT"] = "nth-kit-dynamic-layout-next";
  NarvarEventComponents["NTH_PACK_EDD_PANEL"] = "nth-pack-edd-panel";
  NarvarEventComponents["NTH_PACK_FEEDBACK"] = "nth-pack-feedback";
  NarvarEventComponents["NTH_PACK_GIFT_TRACKING"] = "nth-pack-gift-tracking";
  NarvarEventComponents["NTH_PACK_NOTIFICATION_CENTER"] = "nth-pack-notification-center";
  NarvarEventComponents["NTH_PACK_EMAIL_NOTIFICATION_CENTER"] = "nth-pack-email-notification-center";
  NarvarEventComponents["NTH_PACK_APP_PUSH_NOTIFICATION_CENTER"] = "nth-pack-app-push-notification-center";
  NarvarEventComponents["NTH_PACK_LINE_NOTIFICATION_CENTER"] = "nth-pack-line-notification-center";
  NarvarEventComponents["NTH_PACK_ITEMS_IN_THIS_SHIPMENT"] = "nth-pack-items-in-this-shipment";
  NarvarEventComponents["NTH_PACK_MORE_INFORMATION"] = "nth-pack-more-information";
  NarvarEventComponents["NTH_PACK_PICKUP_LOCATION"] = "nth-pack-pickup-location";
  NarvarEventComponents["NTH_PACK_SHIPMENTS"] = "nth-pack-shipments";
  NarvarEventComponents["NTH_KIT_CHAT"] = "nth-kit-chat";
  return NarvarEventComponents;
}({});
const MULTIPLE_COMPONENTS = 'multiple-components';
const MULTIPLE_FEATURES = 'multiple-features';
const DEFAULT_ANALYTICS_CONTEXT = {
  data: {
    eventSchema: '',
    pageRetailerMoniker: '',
    productName: '',
    tag: noflakeSchema.NoflakeTag.BAD
  },
  isHipaaCompliant: false,
  noflakeUrl: 'https://titanlite-235686439465.us-central1.run.app/v2/noflake',
  errorCallback: err => console.error(err) // eslint-disable-line no-console
};

const QUEUE_INTERVAL = 1;
const COMPONENT_RENDER_QUEUE_INTERVAL = 5000;
let componentRenderEvent;
const eventQueue = [];
let dequeueing = false;
const guidStorage = storage["default"](storage.StorageType.LOCAL_STORAGE, storage.Keyspace.GUID);
const requestUuidStorage = storage["default"](storage.StorageType.SESSION_STORAGE, storage.Keyspace.REQUEST_UUID);
const postToNoflake = async _ref => {
  let {
    data,
    isHipaaCompliant,
    noflakeUrl,
    errorCallback
  } = _ref;
  const {
    id,
    dateCreated: guidDateCreated = null
  } = guidStorage.get(errorCallback) || {};
  const guid = id || '';
  const requestUuid = requestUuidStorage.get(errorCallback) || null;
  const {
    browser_fingerprint: clientBrowserFingerprint,
    browser_name: clientBrowserName,
    browser_version: clientBrowserVersion,
    device_mem_gb: clientDeviceMemGb,
    device_model: clientDeviceModel,
    device_net_speed_mbps: clientDeviceNetSpeedMbps,
    device_net_type: clientDeviceNetType,
    device_num_processors: clientDeviceNumProcessors,
    device_size_px: clientDeviceSizePx,
    device_touchpoints: clientDeviceTouchpoints,
    device_type: clientDeviceType,
    device_vendor: clientDeviceVendor,
    language: clientBrowserLanguage,
    os_name: clientDeviceOsName,
    os_version: clientDeviceOsVersion,
    time_offset_mins_to_utc: clientDeviceTimeOffsetMinsToUtc
  } = await deviceProfiler__default["default"];
  const {
    document: {
      referrer: pageReferrerUrl,
      title: pageTitle
    },
    location: {
      href: pageUrl
    },
    navigator: {
      vendor: clientDeviceNavigatorVendor = null
    },
    origin: pageHost
  } = window;
  const providedData = {
    clientBrowserFingerprint,
    clientBrowserLanguage,
    clientBrowserName,
    clientBrowserVersion,
    clientDeviceMemGb,
    clientDeviceModel,
    clientDeviceNetSpeedMbps,
    clientDeviceNetType,
    clientDeviceNumProcessors,
    clientDeviceOsName,
    clientDeviceOsVersion,
    clientDeviceSizePx,
    clientDeviceTimeOffsetMinsToUtc,
    clientDeviceTouchpoints,
    clientDeviceType,
    clientDeviceVendor: clientDeviceVendor || clientDeviceNavigatorVendor,
    deviceId: guid,
    eventTs: new Date().toISOString(),
    guid,
    guidDateCreated,
    pageHost,
    pageReferrerUrl,
    pageTitle,
    pageUrl,
    requestUuid
  };
  const payload = {
    // Required
    eventType: '',
    // Optional
    bannerSegmentId: null,
    bannerSegmentName: null,
    chatClientSessionId: null,
    clickAssetId: null,
    clickAssetMultilinkId: null,
    clickAssetSchdEndDateUtc: null,
    clickAssetSchdStartDateUtc: null,
    clickAssetType: null,
    clickAssetUrl: null,
    clickCategory: null,
    clickDeliveryInstructionsComment: null,
    clickDeliveryInstructionsLocation: null,
    clickLinkDestinationUrl: null,
    clickLinkLabel: null,
    clickLocationId: null,
    clickNotificationIsChangeNumber: null,
    clickNotificationIsOptIn: null,
    clickNotificationIsOptOut: null,
    clickNotificationMarketingOptInChecked: null,
    clickNotificationOptInDisclaimerText: null,
    clickNotificationMarketingPrivacyLink: null,
    clickNotificationMarketingTermsLink: null,
    clickNotificationMarketingOptInText: null,
    clickNotificationIsOrderLevelSignup: null,
    clickProductRecItemData: null,
    clickProductRecItemIndex: null,
    clickProductRecItemName: null,
    clickRedirectSuccessLocation: null,
    clickRedirectSuccessName: null,
    clickSubType: null,
    clickSurveyComment: null,
    clickSurveyRating: null,
    clickType: null,
    clientCity: null,
    clientCountry: null,
    clientLat: null,
    clientLong: null,
    clientRegion: null,
    config: null,
    customerId: null,
    displayedEddBegin: null,
    displayedEddEnd: null,
    displayedLocations: null,
    eventCarrierMoniker: null,
    eventComponent: null,
    eventFeature: null,
    eventId: null,
    eventItemGroup: null,
    eventNotificationSignUpError: null,
    eventNotificationSmsValidationError: null,
    eventNotificationEmailValidationError: null,
    eventTrackStatus: null,
    eventTrackSubStatus: null,
    eventTrackingNumber: null,
    feature: null,
    ingestionTimestamp: null,
    isFallbackView: null,
    orderNumber: null,
    pageCarrierService: null,
    pageComponent: null,
    pageEddFormatted: null,
    pageHasConciergeSelected: null,
    pageHasEdd: null,
    pageLoadMs: null,
    pageLocaleCountry: null,
    pageLocaleLanguage: null,
    pageOrderNumber: null,
    pageShipmentStatus: null,
    pageTrackType: null,
    pageUiLoadMs: null,
    pageUrlLocale: null,
    pageVersionName: null,
    provider: null,
    requestPage: null,
    requestSource: null,
    segmentId: null,
    segmentName: null,
    trackEddBegin: null,
    trackEddEnd: null,
    trackEddSource: null,
    trackLayout: null,
    zipcodeLocation: null,
    // Data from context
    ...data,
    // Data provided automatically
    ...providedData
  };
  const allowedFieldsForHipaa = ['bannerSegmentId', 'bannerSegmentName', 'clickAssetId', 'clickAssetMultilinkId', 'clickAssetSchdEndDateUtc', 'clickAssetSchdStartDateUtc', 'clickAssetType', 'clickAssetUrl', 'clickCategory', 'clickLinkLabel', 'clickNotificationIsChangeNumber', 'clickNotificationIsOptIn', 'clickNotificationIsOptOut', 'clickNotificationMarketingOptInChecked', 'clickNotificationOptInDisclaimerText', 'clickNotificationMarketingPrivacyLink', 'clickNotificationMarketingTermsLink', 'clickNotificationMarketingOptInText', 'clickNotificationIsOrderLevelSignup', 'clickProductRecItemData', 'clickProductRecItemIndex', 'clickProductRecItemName', 'clickSubType', 'clickSurveyComment', 'clickSurveyRating', 'clickType', 'clientCountry', 'config', 'eventCarrierMoniker', 'eventComponent', 'eventFeature', 'eventId', 'eventItemGroup', 'eventSchema', 'eventTrackStatus', 'eventTrackSubStatus', 'eventTs', 'eventType', 'feature', 'guidDateCreated', 'ingestionTimestamp', 'isFallbackView', 'pageCarrierService', 'pageComponent', 'pageEddFormatted', 'pageHasConciergeSelected', 'pageHasEdd', 'pageHost', 'pageLoadMs', 'pageLocaleCountry', 'pageRetailerMoniker', 'pageShipmentStatus', 'pageTitle', 'pageTrackType', 'pageVersionName', 'productName', 'provider', 'requestPage', 'requestSource', 'requestUuid', 'segmentId', 'segmentName', 'tag', 'trackLayout'];

  // Merge analytics payload with noflake schema, decamelizing at the same time
  const noflakePayload = Object.entries(payload).reduce((acc, _ref2) => {
    let [camelKey, value] = _ref2;
    // We disallow certain fields from being sent to noflake if the retailer isHipaaCompliant.
    if (isHipaaCompliant && !allowedFieldsForHipaa.includes(camelKey)) {
      return acc;
    }
    const [snakeKey, noFlakeValue] = decamelize["default"](camelKey, value);
    acc[snakeKey] = noFlakeValue;
    return acc;
  }, {});
  try {
    // `keepalive: true` allows our analytics requests to outlive the current page
    await fetch(noflakeUrl, {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(noflakePayload)
    });
  } catch (err) {
    errorCallback(err);
  }
};
const dequeue = async () => {
  const analyticsEvent = eventQueue[0];
  if (analyticsEvent && analyticsEvent.data !== DEFAULT_ANALYTICS_CONTEXT.data && !dequeueing) {
    try {
      dequeueing = true;
      await postToNoflake(analyticsEvent);
      eventQueue.shift();
      dequeueing = false;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error posting to noflake:', err);
    }
  }
};

// TODO: refactor instead of disabling
// eslint-disable-next-line @typescript-eslint/no-misused-promises
let dequeInterval = setInterval(dequeue, QUEUE_INTERVAL);
const enqueueComponentRender = () => {
  if (!componentRenderEvent) return;
  eventQueue.push(componentRenderEvent);
  componentRenderEvent = null;
};
let enqueueComponentRenderInterval = setInterval(enqueueComponentRender, COMPONENT_RENDER_QUEUE_INTERVAL);
const setDequeInterval = ms => {
  clearInterval(dequeInterval);
  // TODO: refactor instead of disabling
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  dequeInterval = setInterval(dequeue, ms);
};
const setEnqueueComponentRenderInterval = ms => {
  clearInterval(enqueueComponentRenderInterval);
  enqueueComponentRenderInterval = setInterval(enqueueComponentRender, ms);
};
const flushAnalyticsQueue = async () => {
  while (eventQueue.length > 0) {
    await postToNoflake(eventQueue[0]);
    eventQueue.shift();
  }
};

// Useful for firing off all queued events left when navigating away from
// the page in the same browser window. Combined with { keep-alive: true }
// used in postToNoflake, we can fire all remaining analytics events
// essentially all at once, and have confidence they'll complete without
// having to await them
const flushAnalyticsQueueSync = () => {
  while (eventQueue.length > 0) {
    // eslint-disable-next-line no-console
    postToNoflake(eventQueue[0]).catch(err => console.log(err));
    eventQueue.shift();
  }
};
const AnalyticsContext = /*#__PURE__*/react.createContext(DEFAULT_ANALYTICS_CONTEXT);
const useAnalyticsContext = () => react.useContext(AnalyticsContext);
const AnalyticsProvider = AnalyticsContext.Provider;
const useAnalyticsPost = () => {
  const context = react.useContext(AnalyticsContext);
  const logEvent = react.useCallback(data => {
    if (typeof window === 'undefined') return;
    const {
      data: contextData,
      noflakeUrl,
      isHipaaCompliant,
      errorCallback,
      skip = false
    } = context;
    if (skip === true) return;
    const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    const id = `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;

    // guid will be set the first time we initialize analytics context
    if (guidStorage.isEmpty(errorCallback) || guidStorage.isExpired(errorCallback)) {
      guidStorage.set({
        id,
        dateCreated: new Date().toISOString()
      }, errorCallback);
    }
    if (requestUuidStorage.isEmpty(errorCallback)) {
      requestUuidStorage.set(id, errorCallback);
    }
    if (data.eventType === NarvarEventTypes.COMPONENT_RENDER && contextData.eventSchema === noflakeSchema.NoflakeTag.COMPONENT_PLATFORM) {
      const {
        data: componentRenderData,
        data: {
          config = []
        } = {}
      } = componentRenderEvent || {};

      // Merge all component_render events into one main payload.
      // The ...data spread has the potential to overwrite keys from previous
      // payloads, but that's cool since the merged component_render payload
      // shouldn't be used for looking at component details anyways. We just
      // want as much info as possible.
      const renderConfigData = {
        name: data.feature || 'feature name not specified by render context',
        options: [`nth-source:${(data === null || data === void 0 ? void 0 : data.eventComponent) ?? ''}`]
      };
      componentRenderEvent = {
        data: {
          ...componentRenderData,
          ...contextData,
          ...data,
          config: config && config.length ? [...config, renderConfigData] : [renderConfigData],
          ...(config && config.length && {
            eventComponent: MULTIPLE_COMPONENTS,
            eventFeature: MULTIPLE_COMPONENTS,
            feature: MULTIPLE_FEATURES,
            pageComponent: MULTIPLE_COMPONENTS
          })
        },
        noflakeUrl,
        errorCallback
      };
      return;
    }
    eventQueue.push({
      data: {
        ...contextData,
        ...data
      },
      isHipaaCompliant,
      noflakeUrl,
      errorCallback
    });
  }, [context]);
  const logEventRef = react.useRef(logEvent);
  react.useEffect(() => {
    logEventRef.current = logEvent;
  }, [logEventRef, logEvent]);
  return react.useCallback(function () {
    return logEventRef.current(...arguments);
  }, [logEventRef]);
};

exports.AnalyticsContext = AnalyticsContext;
exports.AnalyticsProvider = AnalyticsProvider;
exports.COMPONENT_RENDER_QUEUE_INTERVAL = COMPONENT_RENDER_QUEUE_INTERVAL;
exports.DEFAULT_ANALYTICS_CONTEXT = DEFAULT_ANALYTICS_CONTEXT;
exports.NarvarClickSubTypes = NarvarClickSubTypes;
exports.NarvarClickTypes = NarvarClickTypes;
exports.NarvarEventComponents = NarvarEventComponents;
exports.NarvarEventTypes = NarvarEventTypes;
exports.QUEUE_INTERVAL = QUEUE_INTERVAL;
exports.flushAnalyticsQueue = flushAnalyticsQueue;
exports.flushAnalyticsQueueSync = flushAnalyticsQueueSync;
exports.setDequeInterval = setDequeInterval;
exports.setEnqueueComponentRenderInterval = setEnqueueComponentRenderInterval;
exports.useAnalyticsContext = useAnalyticsContext;
exports.useAnalyticsPost = useAnalyticsPost;
